import React from 'react'
import NRTButton from "../Button/index"
import ArrowRight from "../../_icons/ArrowRight"


const NRTBackButton = (props) => (
    <NRTButton
        small
        secondary
        noBorder
        outline
        iconButton
        style={{
            width: 'fit-content',
            padding: 0
        }}
        className={'back-button'}

        {...props}

    >

        <ArrowRight width={15} height={15}
                    style={{
                        transform: 'rotate(180deg)',
                        marginRight: '.3rem'
                    }}/>

        Voltar
    </NRTButton>
)


NRTBackButton.propTypes = {}

NRTBackButton.defaultProps = {}

export default NRTBackButton



// WEBPACK FOOTER //
// ./src/components/_common/_buttons/BackButton/index.js